import { SKU } from 'domains/skuDomain';

export const useSkuHideSaveAsNew = (mainSku?: SKU) => {
  return (
    !mainSku ||
    !(
      (mainSku?.isBaseSku && Number(localStorage.getItem('org')) === 1) ||
      (!mainSku?.isBaseSku && Number(localStorage.getItem('org')) !== 1)
    )
  );
};
